import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SizeCode } from 'entities/SizeCode';
import { Warehouse } from 'entities/Warehouse';
import { ChangePricesModalSchema, changePricesSteps, DEFAULT_RATE_TYPES, PriceChangeDirection, PriceChangeParams } from '../types';

const initialPriceChangeParams: PriceChangeParams = {
  direction: PriceChangeDirection.INCREASE,
  percent: null,
  rateTypes: [...DEFAULT_RATE_TYPES],
};

const initialState: ChangePricesModalSchema = {
  isOpened: false,
  steps: changePricesSteps,
  selectedWarehouse: null,
  selectedSizeCodes: [],
  priceChangeParams: initialPriceChangeParams,
};

const changePricesModalSlice = createSlice({
  name: 'changePricesModal',
  initialState,
  reducers: {
    setOpened: (state: ChangePricesModalSchema, action: PayloadAction<boolean>) => {
      state.isOpened = action.payload;
    },
    changeStepData: (state: ChangePricesModalSchema, action: PayloadAction<{ targetStepIndex: number; stepData: string }>) => {
      state.steps = state.steps.map((step, index) =>
        index === action.payload.targetStepIndex ? { ...step, stepData: action.payload.stepData } : step,
      );
    },
    setSelectedWarehouse: (state: ChangePricesModalSchema, action: PayloadAction<Warehouse>) => {
      const isSameWarehouse = state.selectedWarehouse?.warehouseId === action.payload.warehouseId;

      state.selectedWarehouse = action.payload;

      if (!isSameWarehouse) {
        state.selectedSizeCodes = [];
      }
    },
    setSelectedSizeCodes: (state: ChangePricesModalSchema, action: PayloadAction<SizeCode[]>) => {
      state.selectedSizeCodes = action.payload;
    },
    setPriceChangeParams: (state: ChangePricesModalSchema, action: PayloadAction<PriceChangeParams>) => {
      state.priceChangeParams = action.payload;
    },
    resetModalState: (state: ChangePricesModalSchema) => {
      state.isOpened = false;
      state.steps = changePricesSteps;
      state.selectedWarehouse = null;
      state.selectedSizeCodes = [];
      state.priceChangeParams = {
        direction: PriceChangeDirection.INCREASE,
        percent: null,
        rateTypes: [...DEFAULT_RATE_TYPES],
      };
    },
  },
});

export const { actions: changePricesModalActions, reducer: changePricesModalReducer } = changePricesModalSlice;
